<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="''" />
		<template v-if="ledger.ledger_type != 'customer_order'">
			<CommonFlame :title="ledger.name">
				<!-- app-barに表示するボタン群 -->
				<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
					<LedgerInfoDialog text v-if="ledger.name" :ledger="ledger" :authorized="authorized" />
					<SearchDialog
						text
						:query.sync="q"
						:sorts="ledger.ledger_sorts"
						:searchForms="ledger.ledger_search_forms"
						@search-items="searchItems($event)"
					/>
				</template>
				<template v-if="$vuetify.breakpoint.xs">
					<v-row no-gutters justify="end" class="mb-2">
						<LedgerInfoDialog v-if="ledger.name" :ledger="ledger" :authorized="authorized" />
						<SearchDialog
							:query.sync="q"
							:sorts="ledger.ledger_sorts"
							:searchForms="ledger.ledger_search_forms"
							@search-items="searchItems($event)"
						/>
					</v-row>
				</template>
				<div class="table-container mt-2">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="items"
						item-key="name"
						class="elevation-1"
						:mobile-breakpoint="240"
						disable-filtering
						disable-pagination
						disable-sort
						hide-default-footer
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<ItemRecord
								:key="item.id"
								:item="item"
								:columns="ledger.ledger_columns"
								:authorityType="authorityType"
								@change-value="changeValue($event, item)"
								:ref="`itemRecord-${item.id}`"
							/>
						</template>
					</v-data-table>
				</div>
				<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
			</CommonFlame>
		</template>
		<template v-else>
			<IntegratedLedger
				v-if="componentName == 'IntegratedLedger'"
				:items="items"
				:query.sync="q"
				:pagination="pagination"
				:initialData="initialData"
				@get-page="getPage($event)"
				@fetch-items="fetchItems(false, pagination.current)"
				@search-items="searchItems($event)"
			/>
			<PaintLedger
				v-else-if="componentName == 'PaintLedger'"
				:items="items"
				:authorized="authorized"
				:query.sync="q"
				:pagination="pagination"
				:renderData="renderData"
				@get-page="getPage($event)"
				@fetch-items="fetchItems(false, pagination.current)"
				@search-items="searchItems($event)"
			/>
			<UnapprovedListLedger
				v-else-if="componentName == 'UnapprovedListLedger'"
				:pagination="pagination"
				:renderData="renderData"
				:authorized="authorized"
				@get-page="getPage($event)"
				@update-list="updateList($event)"
				@delete-query="deleteQuery"
			/>
			<!-- <ProcessLedger
				v-else-if="componentName == 'ProcessLedger'"
				:items="items"
				:authorized="authorized"
				:query.sync="q"
				:pagination="pagination"
				:initialData="initialData"
				@get-page="getPage($event)"
				@fetch-items="fetchItems(false, pagination.current)"
				@search-items="searchItems($event)"
			/> -->
		</template>
	</v-sheet>
</template>

<script>
import axios from "axios"
import Qs from "qs"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import ItemRecord from "./components/LedgerItemRecord.vue"
import PaginationModule from "../shared/PaginationModule.vue"
import SearchDialog from "./components/LedgerSearchDialog.vue"
import LedgerInfoDialog from "./components/LedgerInfoDialog.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import ledgerHelper from "../../helper/ledgerHelper"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		ItemRecord,
		PaginationModule,
		SearchDialog,
		LedgerInfoDialog,
		IntegratedLedger: () => import("./customer_orders/IntegratedLedger.vue"),
		PaintLedger: () => import("./customer_orders/PaintLedger.vue"),
		UnapprovedListLedger: () => import("./customer_orders/UnapprovedListLedger.vue"),
		ProcessLedger: () => import("./customer_orders/ProcessLedger.vue"),
	},
	data() {
		return {
			mainTitle: "台帳",
			id: this.$route.params.id,
			componentName: null,
			renderData: null,
			initialData: null,
			headers: [],
			q: {
				sorts: null,
			},
			ledger: {
				name: "",
				department: { id: null, name: null },
				ledger_columns: [],
				ledger_filters: [],
				ledger_sorts: [],
				ledger_search_forms: [],
			},
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			authorized: false,
			authorityType: null,
			items: [],
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.setQuery()
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchItems(true, page)
	},
	methods: {
		searchItems(q) {
			this.q = q
			this.fetchItems(false, 1)
			this.$router.push({
				name: "ledger_show",
				query: { ...this.q, page: 1 },
			})
		},
		getPage(i) {
			this.fetchItems(false, i)
			this.$router.push({
				name: "ledger_show",
				query: { ...this.q, page: i },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		fetchItems(first_visit, page) {
			const headers = authenticate.setHeader()
			const params = { q: this.q, page, first_visit }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			const url = `/erp/v1/ledgers/${this.id}`
			axios
				.get(url, { headers, params, paramsSerializer })
				.then((res) => {
					this.items = res.data.items
					this.pagination = res.data.pagination
					this.ledger = res.data.ledger
					if (first_visit) {
						this.authorized = res.data.authorized
						this.initialData = res.data.initial_data
					}
					if (this.ledger.ledger_type == "customer_order") {
						this.renderData = res.data.render_data
						this.componentName = res.data.component_name
						return
					}
					if (first_visit) {
						if (this.ledger.exclusive_flag) {
							const authority = this.ledger.ledger_authorities.find(
								(a) => a.user_id == this.$store.getters["auth/authData"].id
							)
							this.authorityType = authority ? authority.authority_type : null
						} else {
							this.authorityType = "edit"
						}
						this.setTableHeaders(this.sortByOrderNumber(this.ledger.ledger_columns))
						this.setSearchForms(this.ledger.ledger_search_forms)
					}
					const columns = this.ledger.ledger_columns.filter(
						(c) => c.special_type == "fetch_function"
					)
					columns.forEach((c) => {
						ledgerHelper[c.special_string](this)
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setTableHeaders(columns) {
			this.headers = columns.map((c) => ({
				text: c.name,
				value: c.order_number,
				width: c.width ? `${c.width}px` : this.expectingWidth(c.column_type),
				divider: true,
			}))
		},
		setSearchForms(searchForms) {
			let q = Object.assign(this.q)
			searchForms.forEach((searchForm) => {
				if (
					this.q[this.searchParams(searchForm)] == null ||
					this.q[this.searchParams(searchForm)] == []
				) {
					if (searchForm.form_type == "multi_select" || searchForm.form_type == "checkbox") {
						q[this.searchParams(searchForm)] = []
					} else {
						q[this.searchParams(searchForm)] = null
					}
				}
			})
			this.q = q
		},
		setQuery() {
			const query = this.$route.query
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					this.q[query_key] = this.formatQuery(query[query_key])
				}
			})
		},
		deleteQuery(keys) {
			let query = Object.assign({}, this.$route.query)
			keys.forEach((key) => delete query[key])
			this.$router.push({ query: query })
		},
		changeValue(newItem, item) {
			const index = this.items.indexOf(item)
			this.$set(this.items, index, newItem)
			const columns = this.ledger.ledger_columns.filter((c) => c.special_type == "fetch_function")
			columns.forEach((c) => {
				ledgerHelper[c.special_string](this)
			})
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		searchParams(searchForm) {
			if (searchForm.base_model) {
				return `${searchForm.base_model}_${searchForm.column_name}${searchForm.condition}`
			} else {
				return `${searchForm.column_name}${searchForm.condition}`
			}
		},
		sortByOrderNumber(columns) {
			return columns.sort((a, b) => {
				if (a.order_number < b.order_number) return -1
				if (a.order_number > b.order_number) return 1
				return 0
			})
		},
		expectingWidth(columnType) {
			switch (columnType) {
				case "integer":
				case "float":
					return "150px"
				case "string":
				case "text":
					return "200px"
				case "date":
					return "100px"
				case "datetime":
					return "150px"
				case "boolean":
					return "80px"
				default:
					return "200px"
			}
		},
		updateList(id) {
			const result = this.renderData.filter((item) => {
				return item.id != id
			})
			this.renderData = result
		},
	},
	computed: {},
}
</script>

<style lang="scss" scoped>
.table-container {
	width: 100%;
	overflow-x: scroll;
	.v-data-table {
		width: auto;
	}
}
</style>
